import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { Button, Dialog } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';

const ExpansionSummaryVerificationComponent = ({ verification, onCloseModal }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      id='expansion-summary-verification-dialog'
      open
      disableBackdropClick
      fullWidth
      maxWidth={'md'}
      onClose={onCloseModal}
      title={t('Offer.Edit.Verifications.SummaryTitle')}
      content={
        <Grid container justifyContent={'center'}>
          <div dangerouslySetInnerHTML={{ __html: verification.summary }} />
        </Grid>
      }
      actions={
        <Button color={'primary'} onClick={onCloseModal}>
          {t('General.Close')}
        </Button>
      }
    />
  );
};

ExpansionSummaryVerificationComponent.propTypes = {
  verification: PropTypes.array,
  onCloseModal: PropTypes.func
};

export default ExpansionSummaryVerificationComponent;
